import FieldConfig from "../../../../proto/field-config"
import FieldDate from "../../../../generic/datetime/date/date"
import ItemModel from "../../../../../model2/item/item-model"
import TableManager from "../../../../../gd-modules/table/manager/table-manager"
import TaskListManager from "../../../../../gd-modules/task-list/manager/manager"
import {LifecycleAction} from "../../../../../gd/const/lifecycle"
import Project from "../../../../../model2/project/project"
import GanttChartManager from "../../../../../gd-modules/gantt-chart/manager/manager"
import {ViewType} from "../../../../../gd/const/views/view-type"


export default class FieldProjectStartDate extends FieldDate {

    constructor(config:FieldConfig) {
        super(config);

        this.icon               = 'i5-date-start'
        this.label              = 'Start date'

        // this.renderComponents.tableCell     = FieldProto_TableCellReadOnly
        this.fieldParams.tableCellOnValueChange = this.tableCellOnValueChange
    }

    // ACCESS
    canEdit(model:Project):boolean {
        return model.acl.canChangeStartDate
    }


    // Custom Methods

    tableCellOnValueChange = async (item:ItemModel, value:Moment|null, manager:TableManager|TaskListManager|GanttChartManager) => {

        switch (manager.module) {
            case ViewType.PROJECT_GANTT:
            case ViewType.PORTFOLIO_GANTT:
            case ViewType.CUSTOM_VIEW_GANTT:

                const startDate = item.project.displayStartDate || item.project.startDate
                const endDate   = item.project.displayEndDate || item.project.endDate

                const endStartDiff  = moment(endDate).diff(moment(startDate), 'days')
                const newStartDate  = value ? moment(value) : null
                const newEndDate    = value ? moment(value).add(endStartDiff,'days') : null

                const ganttManager = manager as GanttChartManager
                ganttManager.setStartEnd(item.id, newStartDate, newEndDate)

                break

            default:
                item.project.updateStartDate(value, {keepCalendarDuration:true})
                item.project.save()

                item._updateLastUpdateTime() // otherwise it wont re-render

                manager.update([LifecycleAction.PROCESS_DATA, LifecycleAction.RENDER])
                break
        }



    }

}
